let rootFontSize = document.getElementsByTagName('html')[0].style.fontSize
rootFontSize = parseFloat(rootFontSize)
let screenWidth = window.document.documentElement.getBoundingClientRect().width
let innerWidth = window.innerWidth
let width = screenWidth
if (innerWidth && innerWidth <= screenWidth) width = innerWidth
const ratio = width / 375

export function calcRem(num) {
  return (num / rootFontSize) * ratio + 'rem'
}

export function calcRem750(num) {
  return (num / 2 / rootFontSize) * ratio + 'rem'
}

export function calcScalePx750(num) {
  return num * 0.5 * ratio
}
